module.exports = __webpack_public_path__ + "drop.mp3";